// src/components/HRSidebar.js
import React from "react";
import { NavLink } from "react-router-dom";

const SIDEBAR_WIDTH = 260;

const navItemStyle = {
  display: "flex",
  alignItems: "center",
  gap: "12px",
  padding: "12px 18px",
  borderRadius: 8,
  color: "#333",
  textDecoration: "none",
  fontWeight: 600,
};

export default function HRSidebar() {
  return (
    <aside className="hr-sidebar" style={{ width: SIDEBAR_WIDTH, background: "#ffb300", minHeight: "100vh", padding: 18 }}>
      <div style={{ textAlign: "center", marginBottom: 18 }}>
        <img
          src="/vmsc_logo.png"
          alt="logo"
          style={{ width: 84, height: 84, borderRadius: "50%", objectFit: "cover", border: "2px solid #ff9800" }}
        />
      </div>

      <nav>
        <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
          <li style={{ marginBottom: 6 }}>
            <NavLink
              to="/hr/payroll"
              className="nav-link"
              style={({ isActive }) => ({
                ...navItemStyle,
                background: isActive ? "#fff" : "transparent",
                boxShadow: isActive ? "0 4px 12px rgba(255,152,0,0.12)" : "none",
                color: "#333",
                borderLeft: isActive ? "4px solid #ff9800" : "4px solid transparent",
              })}
            >
              <i className="bi bi-cash-stack" style={{ fontSize: 18 }}></i>
              Payroll Dashboard
            </NavLink>
          </li>
          <li style={{ marginBottom: 6 }}>
            <NavLink
              to="/hr/employees"
              style={({ isActive }) => ({
                ...navItemStyle,
                background: isActive ? "#fff" : "transparent",
                boxShadow: isActive ? "0 4px 12px rgba(255,152,0,0.12)" : "none",
                borderLeft: isActive ? "4px solid #ff9800" : "4px solid transparent",
              })}
            >
              <i className="bi bi-people" style={{ fontSize: 18 }}></i>
              Employee Management
            </NavLink>
          </li>
          <li style={{ marginBottom: 6 }}>
            <NavLink
              to="/hr/attendance-daily"
              style={({ isActive }) => ({
                ...navItemStyle,
                background: isActive ? "#fff" : "transparent",
                boxShadow: isActive ? "0 4px 12px rgba(255,152,0,0.12)" : "none",
                borderLeft: isActive ? "4px solid #ff9800" : "4px solid transparent",
              })}
            >
              <i className="bi bi-clipboard-check" style={{ fontSize: 18 }}></i>
              Daily Attendance
            </NavLink>
          </li>
          <li style={{ marginBottom: 6 }}>
            <NavLink
              to="/hr/reports"
              style={({ isActive }) => ({
                ...navItemStyle,
                background: isActive ? "#fff" : "transparent",
                boxShadow: isActive ? "0 4px 12px rgba(255,152,0,0.12)" : "none",
                borderLeft: isActive ? "4px solid #ff9800" : "4px solid transparent",
              })}
            >
              <i className="bi bi-bar-chart" style={{ fontSize: 18 }}></i>
              HR Reports
            </NavLink>
          </li>

          {/* Switch System Section */}
          <li style={{ marginTop: 24 }}>
            <div style={{ padding: "0 18px", marginBottom: 12 }}>
              <div style={{ fontSize: 14, fontWeight: 700, textTransform: "uppercase", letterSpacing: 1, opacity: 0.8, color: "#5d4037" }}>
                Switch System
              </div>
            </div>
          </li>
          <li style={{ marginBottom: 6 }}>
            <NavLink
              to="/finance/dashboard"
              style={({ isActive }) => ({
                ...navItemStyle,
                background: isActive ? "#fff" : "transparent",
                boxShadow: isActive ? "0 4px 12px rgba(255,152,0,0.12)" : "none",
                borderLeft: isActive ? "4px solid #ff9800" : "4px solid transparent",
              })}
            >
              <i className="bi bi-cash" style={{ fontSize: 18 }}></i>
              Finance System
            </NavLink>
          </li>
          <li style={{ marginBottom: 6 }}>
            <NavLink
              to="/sis/dashboard"
              style={({ isActive }) => ({
                ...navItemStyle,
                background: isActive ? "#fff" : "transparent",
                boxShadow: isActive ? "0 4px 12px rgba(255,152,0,0.12)" : "none",
                borderLeft: isActive ? "4px solid #ff9800" : "4px solid transparent",
              })}
            >
              <i className="bi bi-mortarboard" style={{ fontSize: 18 }}></i>
              Student Information System
            </NavLink>
          </li>
        </ul>
      </nav>
    </aside>
  );
}
